import _ from 'lodash-es'
import barba from '@barba/core'
import gsap from 'gsap'

export default class ImageParallax {
  constructor (els) {
    this.images = els
    this.timelines = []
    this.init()

    // pause on page leave
    barba.hooks.beforeLeave(() => {
      this.timelines.forEach((tl, i) => {
        tl.pause()
        this.timelines.splice(i, 1)
      })
    })
  }

  init () {
    if (this.images?.length) {
      this.images.forEach(el => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            scrub: true,
            start: 'top bottom',
            end: 'bottom top'
          },
          ease: 'none'
        })
  
        tl.fromTo(
          el,
          {
            yPercent: -20
          },
          {
            yPercent: 20,
            ease: 'power1.out',
            duration: 1
          },
          0
        )

        this.timelines.push(tl)
      })
    }
  }
}
